import InvitePlayer from './InvitePlayer';

export default InvitePlayer;